import { render, staticRenderFns } from "./APIGatewayEdit.vue?vue&type=template&id=5b39ede5"
import script from "./APIGatewayEdit.vue?vue&type=script&lang=js"
export * from "./APIGatewayEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports